import { EquipmentFormValue } from "../types";

export function prepareCreateUpdateEquipmentDTO(formData: EquipmentFormValue) {
  const { commonInfo, attachments } = formData;

  return {
    attachments,
    year: commonInfo.year,
    make: commonInfo.make,
    model: commonInfo.model,
    mileage: commonInfo.mileage,
    stockId: commonInfo.stockId,
    quantity: commonInfo.quality,
    truckClass: commonInfo.class,
    newUsed: commonInfo.condition,
    wholesaleCost: commonInfo.saleCost,
    retailPrice: commonInfo.retailPrice,
    serialNumberVin: commonInfo?.vin?.trim(),
    totalWholesaleCost: commonInfo.wholeSaleCost,
    discountValue: commonInfo.discountValue ?? 0,
    additionalDescription: commonInfo.description,
    discountType: commonInfo.discountType ?? null,
  };
}
